import { Injectable, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { of } from 'rxjs';
import { BreadcrumbDataSource } from '../components/breadcrumb/breadcrumb-data';
import { IBreadcrumbHome } from '../components/breadcrumb/breadcrumb.component';

export declare type BreadcrumbLabel = string | string[];

@Injectable({ providedIn: 'root' })
export class BreadcrumbService {
  public dataSource: BreadcrumbDataSource<BreadcrumbLabel>;
  public home: IBreadcrumbHome = {
    routerLink: ['/'],
  };

  constructor() {
    const router = inject(Router);
    const activatedRoute = inject(ActivatedRoute);

    this.dataSource = new BreadcrumbDataSource<BreadcrumbLabel>(router, activatedRoute);
    this.dataSource.transform = (data: BreadcrumbLabel) => {
      if (Array.isArray(data)) {
        return of([...data].join(''));
      }

      return of(data);
    };
  }
}
